<template>
   <Html class="bg-light-grey">
      <ClientOnly>
         <NuxtLoadingIndicator :height="5" color="var(--color-secondary)" />
         <Notification />
      </ClientOnly>

      <Body>
         <PreviewDisclaimer />

         <div
            id="app-layout"
            class="bg-light-grey flex min-h-screen flex-col items-center justify-center gap-10 p-3 max-md:p-2"
         >
            <main class="rounded-small w-full max-w-md overflow-hidden bg-white p-12 max-md:px-6">
               <slot />
            </main>
         </div>
      </Body>
   </Html>
</template>

<script lang="ts" setup>
const { t } = useI18n()

useSeo(t('web.seo.layout.auth.title'), t('web.seo.layout.auth.description'))
</script>
